import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

export interface TextPosition {
  from: number;
  to: number;
}

/**
 * Find all positions of a search string within a ProseMirror document.
 * Case-insensitive, trimmed matching.
 */
export function findTextPositions(
  doc: ProseMirrorNode,
  searchText: string
): TextPosition[] {
  const positions: TextPosition[] = [];
  if (!searchText || searchText.length === 0) return positions;

  const normalizedSearch = searchText.toLowerCase().trim();

  doc.descendants((node, pos) => {
    if (node.isText) {
      const text = node.text?.toLowerCase() ?? '';
      let index = text.indexOf(normalizedSearch);
      while (index !== -1) {
        positions.push({
          from: pos + index,
          to: pos + index + normalizedSearch.length,
        });
        index = text.indexOf(normalizedSearch, index + 1);
      }
    }
  });

  return positions;
}
